import React from 'react'
import SectionHeading from '../HomePage/SectionHeading'
import SectionHeadingWrapper from '../HomePage/SectionHeadingWrapper'
import SectionSubText from '../HomePage/SectionSubText'
import Slider from 'react-slick'
import BookACallPremiumList from '../Buttons/Specials/BookACallPremiumList'

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
        {
            breakpoint: 768, // Adjust this value based on your needs
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
}

const PricingSection = ({ Modal, modalProps }) => {
    return (
        <div className="max-w-5xl mx-auto">
            <div className="text-center">
                <SectionHeadingWrapper>
                    <SectionHeading>
                        <div className="space-x-1">
                            <span>Unlock Your</span>
                            <span className="olm-gradient-text">
                                Investment Potential
                            </span>
                            <br className="hidden md:block" />
                            <span>with Precision Targeted Lists</span>
                        </div>
                    </SectionHeading>
                    <SectionSubText>
                        <div className="px-4">
                            Not sure how to pull a quality list? Need access to
                            a high-performing list to boost your marketing
                            results?
                        </div>
                    </SectionSubText>
                </SectionHeadingWrapper>
            </div>

            <div className="w-10/12 md:w-9/12 mx-auto">
                <Slider {...settings}>
                    <div className="px-0 md:px-4 py-4">
                        <div className="bg-olm-light-yellow border border-olm-yellow rounded-lg p-6 shadow-md">
                            <div className="text-center mb-4">
                                <span className="inline-block border border-olm-yellow bg-olm-yellow-dark text-olm-black px-6 py-2 rounded-full font-bold">
                                    Premium List
                                </span>
                            </div>
                            <p className="text-center text-olm-black mb-4 font-medium">
                                Customized lead lists that match <br /> your
                                investment criteria.
                            </p>
                            <div className="text-center mb-10 text-olm-black">
                                <span className="font-medium">Pricing</span>{' '}
                                <br />
                                <span className="text-3xl font-bold text-olm-black">
                                    15 cents
                                </span>
                                <span className="block text-olm-black">
                                    per record*
                                </span>
                            </div>
                            <p className="text-center text-olm-black text-sm">
                                *Minimum of 1,500 records
                            </p>
                        </div>
                    </div>
                    <div className="px-0 md:px-4 py-4">
                        <div className="bg-primary text-white rounded-lg p-6 shadow-md">
                            <div className="text-center mb-4">
                                <span className="inline-block text-white border border-white px-6 py-2 rounded-full font-bold">
                                    Predictive List
                                </span>
                            </div>
                            <p className="text-center text-white mb-4">
                                Predictive modeling used to identify <br />{' '}
                                highly motivated sellers.
                            </p>
                            <div className="text-center mb-10">
                                <span className="font-medium">Pricing</span>{' '}
                                <br />
                                <span className="text-3xl font-bold">
                                    25 cents
                                </span>
                                <span className="block text-white">
                                    per record*
                                </span>
                            </div>
                            <p className="text-center text-white text-sm">
                                *Minimum of 1,500 records
                            </p>
                        </div>
                    </div>
                </Slider>
            </div>

            {/* <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-8">
                <div className="bg-olm-light-yellow border border-olm-yellow rounded-lg p-6 shadow-md">
                    <div className="text-center mb-4">
                        <span className="inline-block border border-olm-yellow bg-olm-yellow-dark text-olm-black px-6 py-2 rounded-full font-bold">
                            Premium List
                        </span>
                    </div>
                    <p className="text-center text-olm-black mb-4 font-medium">
                        Customized lead lists that match <br /> your investment
                        criteria.
                    </p>
                    <div className="text-center mb-10 text-olm-black">
                        <span className="font-medium">Pricing</span> <br />
                        <span className="text-3xl font-bold text-olm-black">
                            15 cents
                        </span>
                        <span className="block text-olm-black">
                            per record*
                        </span>
                    </div>
                    <p className="text-center text-olm-black text-sm">
                        *Minimum of 1,000 records
                    </p>
                </div>
                <div className="bg-primary text-white rounded-lg p-6 shadow-md">
                    <div className="text-center mb-4">
                        <span className="inline-block text-white border border-white px-6 py-2 rounded-full font-bold">
                            Predictive List
                        </span>
                    </div>
                    <p className="text-center text-white mb-4">
                        Predictive modeling used to identify <br /> highly
                        motivated sellers.
                    </p>
                    <div className="text-center mb-10">
                        <span className="font-medium">Pricing</span> <br />
                        <span className="text-3xl font-bold">25 cents</span>
                        <span className="block text-white">per record*</span>
                    </div>
                    <p className="text-center text-white text-sm">
                        *Minimum of 2,000 records
                    </p>
                </div>
            </div> */}

            <div className="w-11/12 md:w-96 mx-auto mt-12">
                <BookACallPremiumList Modal={Modal} modalProps={modalProps}>
                    Book a Call
                </BookACallPremiumList>
            </div>
        </div>
    )
}

export default PricingSection
